import * as React from "react";

class InfoDialogCContent extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <>
        <section>
          <p>
            不要著急！對抗怕怕病毒慢慢來就好，在那之前，一起舒緩因為怕怕病毒引起的緊張吧！
          </p>
          <div className="title">
            <h2>兔兔的放鬆 TIP</h2>
          </div>
          <h3>1.做好充分的準備</h3>
          <p>
            如果是像上台演說這類可以事先準備，事前準備愈完整，自信也愈足夠，焦慮、緊張之類的症狀也會跟著緩解。可以透過「想像訓練」等方式將流程在腦海中演練過，增加熟悉感以減少不安。
          </p>
          <h3>2.建立正向的自我形象</h3>
          <p>
            吸引力法則：「你越常想著某樣事物，它就越會變成你現實生活的一部分。」「我一定會做不好。」「等等一定會發生不好的事」當你心中充斥著不好的想像時，通常不願發生的事就會成真。
          </p>
          <p>一般人在緊張時，通常會出現以下身體反應，像是：</p>
          <p>
            ．動作不由自主地變快
            <br />
            ．頸部、肩膀肌肉緊繃僵硬
            <br />
            ．聲音顫抖、音調變高 <br />
            ．視線游移不定 <br />
            ．心跳加快、呼吸急促
          </p>
          <h3>3.改變身體姿勢</h3>
          <p>
            已經有研究實驗證明，當人類抬頭挺胸時，會同時增加自信。因為大腦會透過身體姿勢判斷自己的狀態，所以「抬頭挺胸」便會造成「有自信」的錯覺。而露出笑容也有同樣的效果，試著嘴角上揚，即使是假笑也有效果。
          </p>
          <h3>4.深呼吸</h3>
          <p>
            人類的自律神經系統分為交感神經與副交感神經，兩大系統互相影響，就像蹺蹺板一樣。緊張時由交感神經主導，放鬆時則由副交感神經負責。
          </p>
          <p>
            深呼吸可以刺激副交感神經，進而放鬆身心靈。用鼻子緩緩地吸，接著以嘴巴緩緩呼氣。吐氣非常重要喔！(可以想像把內在緊繃的廢氣通通都都排除出去)有一種降低焦慮的7-11法則，吸氣時在內心默數7下，吐氣時默數11下，深呼吸也會隨著練習越練越順暢喔。
          </p>
          <h3>5.穴道按摩</h3>
          <p>
            按摩可以放鬆僵硬的肌肉，促進血液循環。而某些特定的穴道更有幫助放鬆的療效，兔兔幫你找到一些平常就可以輕鬆按壓的穴道，按壓三~五分鐘就有效果囉！
          </p>
          <p>
            ．曲池穴：位於肘關節處，當你掌心向上、手肘彎曲時，可觀察到肘部出現一條橫紋，橫紋外側的終點處即是曲池穴
            <br />
            ．合谷穴：食指與拇指合攏，虎口處肌肉最高處
            <br />
            ．三陰交：足內踝上方四指幅橫寬處
            <br />
          </p>
          <h3>6.精油輔助</h3>
          <p>柑橘類的香氣通常讓人感到放鬆，而在早上使用更可以提振精神。</p>
          <p>
            洋甘菊等精油更有舒緩身心的療效，如果是因為恐懼、焦慮而失眠的人，薰衣草對幫助深層睡眠有極大功效。或是可以直接去找芳療師請他為你的症狀調配更適合的精油喔！
          </p>
          <h3>7.運動、瑜珈</h3>
          <p>
            而經常感到焦慮的人可以透過瑜珈舒展筋骨，讓身心達到平衡。透過運動，尤其是有氧運動，可以幫助降低不安情緒並可促進身體分泌出感到幸福的腦內物質—β腦內啡(β-endorphin)。腦內啡被稱為腦內麻藥，這是屬於體內的報酬性質激素，多分佈於神經系統中，能夠為人體帶來快樂的感覺。
          </p>
          <p>
            運動同時能促進多巴胺（Dopamine）的分泌，達到改善情緒、增加愉悅與提升注意力的目的，使大腦思路也更加清晰。目前也已有研究顯示長期運動可以增加多巴胺在大腦內的儲藏量，並誘發那些負責製造多巴胺受體的酵素生成。
          </p>
          <p>
            血清素同樣也受運動影響，和穩定情緒、記憶、克制衝動與提升自尊心有很大的關聯，它更能跟壓力激素—皮質醇(cortisol)互相對抗，幫助我們釋放壓力。很多抗憂鬱症的藥都是阻擋大腦中血清素的回收，使大腦中的血清素多一點。
          </p>
          <p>所以，現在就跟著兔兔一起來運動吧！</p>
        </section>
        <section>
          <p>
            安撫恐懼和焦慮情緒需要每個人找出一套屬於自己的方法。不能等世界來幫助你，但我們可以陪你一起找到最適合你的解藥！
          </p>
        </section>
      </>
    );
  }
}

export default InfoDialogCContent;



// WEBPACK FOOTER //
// ./src/infoDialogC/components/InfoDialogCContent.tsx